module.exports = __webpack_public_path__ + "static/media/photo248.31cb4064.jpg";